export enum LoginMethod {
	Password = 'Password',
	BankId = 'BankId',
	VerificationCode = 'VerificationCode',
	SSO = 'SSO'
}